import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { formatISODate } from '@/utils/date';
import { SortableHeader, TruncatedCell } from '@/components';
import { VitalRecord } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DocumentSource, DocumentType } from '../../viewer';

export const createVitalsColumns = (): ColumnDef<VitalRecord>[] => [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row }) =>
      row.original.name ? (
        <TruncatedCell text={row.original.name} />
      ) : (
        'No data available'
      ),
  },
  {
    id: 'dateOfStudy',
    accessorKey: 'dateOfStudy',
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Date of Study</SortableHeader>
    ),
    cell: ({ row }) => formatISODate(row.original.dateOfStudy),
  },
  {
    id: 'dateUploaded',
    accessorFn: (row) => row.createdAt,
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Date Uploaded</SortableHeader>
    ),
    cell: ({ row }) =>
      row.original.createdAt
        ? format(new Date(row.original.createdAt), 'MM/dd/yyyy')
        : 'No data available',
  },
  {
    id: 'sourceType',
    accessorFn: (row) => row.sourceTypes,
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Source Type</SortableHeader>
    ),
    cell: ({ row }) => {
      const sourceTypes = row.original.sourceTypes ?? [];
      if (sourceTypes.length === 0) {
        return 'No data available';
      }
      return sourceTypes.join(', ');
    },
  },
  {
    id: 'actions',
    enableSorting: false,
    header: '',
    cell: ({ row }) => {
      const firstSourceType = row.original.sourceTypes[0];
      return (
        <div className="flex items-center justify-end gap-1">
          <PatientDocumentViewButton
            disabled={!firstSourceType}
            documentKey={{
              source: DocumentSource.MEDICAL_RECORDS,
              type: DocumentType.VITALS,
              vitalId: row.original.id,
              sourceType: firstSourceType,
              name: row.original.name,
            }}
          />
        </div>
      );
    },
  },
];
